module.exports = __webpack_public_path__ + "img/icon_map_0_on.9959d1e7.png";